import {
	Button,
	Col,
	DatePicker,
	Divider,
	Form,
	Input,
	InputNumber,
	Row,
	Space,
	Upload,
	message,
	notification,
	Typography,
	Flex,
	Select,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import dayjs from "dayjs";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import SignatureCanvas from "react-signature-canvas";
import { UploadOutlined } from "@ant-design/icons";
const { Text, Title } = Typography;

/**
 ** Options header (columns)
 */
const columns = [
	{
		title: "Date",
		dataIndex: "date",
		key: "date",
		render: (value) => {
			return <Text strong>{value}</Text>;
		},
	},
	{
		title: "User",
		dataIndex: "user",
		key: "user",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Comment",
		dataIndex: "comment",
		key: "comment",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Emails",
		dataIndex: "emails",
		key: "emails",
		render: (value) => {
			return (
				<Flex gap={10} vertical>
					{value.map((email, index) => {
						return <Text key={index}>{email}</Text>;
					})}
				</Flex>
			);
		},
	},
];

const Lien = ({ history, match }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [loadingButton, setLoadingButton] = useState(false);
	const [apiNotification, contextHolder] = notification.useNotification();
	const [initialValues, setInitialValues] = useState({});
	const signaturePadRef = useRef(null);
	const [signatureExist, setSignatureExist] = useState(false);
	const [defaultValueDemandLetter, setDefaultValueDemandLetter] = useState([]);
	const [defaultValueIntentToLien, setDefaultValueIntentToLien] = useState([]);
	const [defaultValueInvoice, setDefaultValueInvoice] = useState([]);
	const [defaultValueLienAffidavit, setDefaultValueLienAffidavit] = useState(
		[]
	);
	const [defaultValueCountyReceipt, setDefaultValueCountyReceipt] = useState(
		[]
	);
	const [defaultValueAgreement1, setDefaultValueAgreement1] = useState([]);

	const [demandLetterRemoved, setDemandLetterRemoved] = useState(false);
	const [demandLetterAdded, setDemandLetterAdded] = useState(false);
	const [intentToLienRemoved, setIntentToLienRemoved] = useState(false);
	const [intentToLienAdded, setIntentToLienAdded] = useState(false);
	const [invoiceRemoved, setInvoiceRemoved] = useState(false);
	const [invoiceAdded, setInvoiceAdded] = useState(false);
	const [lienAffidavitRemoved, setLienAffidavitRemoved] = useState(false);
	const [lienAffidavitAdded, setLienAffidavitAdded] = useState(false);
	const [countyReceiptRemoved, setCountyReceiptRemoved] = useState(false);
	const [countyReceiptAdded, setCountyReceiptAdded] = useState(false);
	const [agreement1Removed, setAgreement1Removed] = useState(false);
	const [agreement1Added, setAgreement1Added] = useState(false);

	const [historyLien, setHistoryLien] = useState([]);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getLien();
	}, []);

	const getLien = async () => {
		setLoading(true);
		try {
			const url = api + "/lien/get/" + match.params.id;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = {
				Authorization: `Bearer ${token}`,
			};
			const { data } = await axios.get(url);
			if (data.success) {
				const lien = data.payload;
				setInitialValues({
					ownerName: lien.ownerName,
					ownerAddress: lien.ownerAddress,
					contractorName: lien.contractorName,
					contractorAddress: lien.contractorAddress,
					companyName: lien.companyName,
					companyAddress: lien.companyAddress,
					propertyAddress: lien.propertyAddress,
					deadline: dayjs(lien.deadline),
					descriptionMaterials: lien.descriptionMaterials,
					dateDelivered: dayjs(lien.dateDelivered),
					amountCharged: lien.amountCharged,
					principalAmountOwned: lien.principalAmountOwned,
					montlyInterestAmount: lien.montlyInterestAmount,
					totalAmountOwned: lien.totalAmountOwned,
					signorName: lien.signorName,
					documentNo: lien.documentNo,
					status: lien.status || "In Process",
				});
				setSignatureExist(lien.signature ? true : false);
				if (lien.demandLetter !== "" && lien.demandLetter !== undefined) {
					const name = lien.demandLetter.split("/")[5];
					setDefaultValueDemandLetter([
						{
							uid: lien._id,
							name: name,
							url: lien.demandLetter,
							status: "done",
						},
					]);
				}
				if (lien.intentToLien !== "" && lien.intentToLien !== undefined) {
					const name = lien.intentToLien.split("/")[5];
					setDefaultValueIntentToLien([
						{
							uid: lien._id,
							name: name,
							url: lien.intentToLien,
							status: "done",
						},
					]);
				}
				if (lien.invoice !== "" && lien.invoice !== undefined) {
					const name = lien.invoice.split("/")[5];
					setDefaultValueInvoice([
						{
							uid: lien._id,
							name: name,
							url: lien.invoice,
							status: "done",
						},
					]);
				}
				if (lien.lienAffidavit !== "" && lien.lienAffidavit !== undefined) {
					const name = lien.lienAffidavit.split("/")[5];
					setDefaultValueLienAffidavit([
						{
							uid: lien._id,
							name: name,
							url: lien.lienAffidavit,
							status: "done",
						},
					]);
				}
				if (lien.countyReceipt !== "" && lien.countyReceipt !== undefined) {
					const name = lien.countyReceipt.split("/")[5];
					setDefaultValueCountyReceipt([
						{
							uid: lien._id,
							name: name,
							url: lien.countyReceipt,
							status: "done",
						},
					]);
				}
				if (lien.agreement1 !== "" && lien.agreement1 !== undefined) {
					const name = lien.agreement1.split("/")[5];
					setDefaultValueAgreement1([
						{
							uid: lien._id,
							name: name,
							url: lien.agreement1,
							status: "done",
						},
					]);
				}

				let historyData = [];

				lien.comments.map((item) => {
					historyData.push({
						index: item._id,
						key: item._id,
						date: new Intl.DateTimeFormat("en-US", {
							month: "numeric",
							year: "numeric",
							day: "numeric",
							hour: "2-digit",
							minute: "2-digit",
							second: "2-digit",
						}).format(new Date(item.createdAt)),
						user: item.user.name,
						comment: item.comment,
						emails: item.emails,
					});
				});

				setHistoryLien(historyData);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to get lien");
			console.error(err.message);
			return null;
		}
	};

	const updateLien = async (values) => {
		setLoadingButton(true);
		const lien = {
			...values,
		};

		delete lien.demandLetter;
		delete lien.intentToLien;
		delete lien.invoice;
		delete lien.lienAffidavit;
		delete lien.countyReceipt;
		delete lien.agreement1;

		if (demandLetterRemoved) {
			lien.demandLetter = "";
		}
		if (intentToLienRemoved) {
			lien.intentToLien = "";
		}
		if (invoiceRemoved) {
			lien.invoice = "";
		}
		if (lienAffidavitRemoved) {
			lien.lienAffidavit = "";
		}
		if (countyReceiptRemoved) {
			lien.countyReceipt = "";
		}
		if (agreement1Removed) {
			lien.agreement1 = "";
		}

		try {
			let url = api + "/lien/update/" + match.params.id;

			const { data } = await axios.patch(url, lien);
			if (data.success) {
				if (signatureExist) {
					if (
						(demandLetterAdded ||
							intentToLienAdded ||
							invoiceAdded ||
							lienAffidavitAdded ||
							countyReceiptAdded ||
							agreement1Added) &&
						(!demandLetterRemoved ||
							!intentToLienRemoved ||
							!invoiceRemoved ||
							!lienAffidavitRemoved ||
							!countyReceiptRemoved ||
							!agreement1Removed)
					) {
						addLienImages(values);
					} else {
						setTimeout(() => {
							setLoadingButton(false);
							history.push("/lien/dashboard");
						}, 2000);
					}
				} else {
					addNewImageSignature(values);
				}
			} else {
				setLoadingButton(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			setLoadingButton(false);
			openNotification("error", "Error", "Error while trying to update lien");
			console.error(err.message);
			return null;
		}
	};

	const addLienImages = async (values) => {
		const formData = new FormData();

		if (
			demandLetterAdded &&
			values.demandLetter &&
			values.demandLetter.length > 0
		) {
			formData.append("demandLetter", values.demandLetter[0].originFileObj);
		}
		if (
			intentToLienAdded &&
			values.intentToLien &&
			values.intentToLien.length > 0
		) {
			formData.append("intentToLien", values.intentToLien[0].originFileObj);
		}
		if (invoiceAdded && values.invoice && values.invoice.length > 0) {
			formData.append("invoice", values.invoice[0].originFileObj);
		}
		if (
			lienAffidavitAdded &&
			values.lienAffidavit &&
			values.lienAffidavit.length > 0
		) {
			formData.append("lienAffidavit", values.lienAffidavit[0].originFileObj);
		}
		if (
			countyReceiptAdded &&
			values.countyReceipt &&
			values.countyReceipt.length > 0
		) {
			formData.append("countyReceipt", values.countyReceipt[0].originFileObj);
		}
		if (agreement1Added && values.agreement1 && values.agreement1.length > 0) {
			formData.append("agreement1", values.agreement1[0].originFileObj);
		}

		if (
			demandLetterAdded ||
			intentToLienAdded ||
			invoiceAdded ||
			lienAffidavitAdded ||
			countyReceiptAdded ||
			agreement1Added
		) {
			try {
				const url = api + `/lien/add/images/${match.params.id}`;
				const token = localStorage.getItem("token");
				axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
				const config = {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				};

				const { data } = await axios.post(url, formData, config);
				if (data.success) {
					openNotification("success", "Success", "Lien Updated");

					setTimeout(() => {
						setLoadingButton(false);
						history.push("/lien/dashboard");
					}, 5000);
				} else {
					setLoadingButton(false);
					openNotification("error", "Error", data.message);
				}
			} catch (err) {
				setLoadingButton(false);
				openNotification("error", "Error", "Error while trying to add images");
				console.error(err.message);
				return null;
			}
		}
	};

	const getCanvasWithWhiteBackground = (canvas) => {
		const newCanvas = document.createElement("canvas");
		const context = newCanvas.getContext("2d");

		// Set canvas dimensions
		newCanvas.width = canvas.width;
		newCanvas.height = canvas.height;

		// Fill the background with white
		context.fillStyle = "#fff";
		context.fillRect(0, 0, newCanvas.width, newCanvas.height);

		// Draw the signature on top
		context.drawImage(canvas, 0, 0);

		return newCanvas;
	};

	const addNewImageSignature = async (values) => {
		const formData = new FormData();

		const originalCanvas = signaturePadRef.current.getTrimmedCanvas();

		// Add a white background to the canvas
		const canvasWithWhiteBackground =
			getCanvasWithWhiteBackground(originalCanvas);

		// Convert the updated canvas to a data URL
		const signatureData = canvasWithWhiteBackground.toDataURL("image/png");

		// Convert Base64 to File
		const base64ToFile = (base64, filename) => {
			const byteString = atob(base64.split(",")[1]);
			const mimeString = base64.split(",")[0].split(":")[1].split(";")[0];
			const ab = new ArrayBuffer(byteString.length);
			const ia = new Uint8Array(ab);
			for (let i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
			}
			return new File([ab], filename, { type: mimeString });
		};

		const signatureFile = base64ToFile(signatureData, "signature.png");

		formData.append("signature", signatureFile);

		try {
			setLoading(true);
			const url = api + `/lien/add/signature/${match.params.id}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
			const config = {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			};

			const { data } = await axios.post(url, formData, config);
			if (data.success) {
				if (
					(demandLetterAdded ||
						intentToLienAdded ||
						invoiceAdded ||
						lienAffidavitAdded ||
						countyReceiptAdded ||
						agreement1Added) &&
					(!demandLetterRemoved ||
						!intentToLienRemoved ||
						!invoiceRemoved ||
						!lienAffidavitRemoved ||
						!countyReceiptRemoved ||
						!agreement1Removed)
				) {
					addLienImages(values);
				} else {
					openNotification("success", "Success", "Lien Updated");
					setTimeout(() => {
						setLoading(false);
						history.push("/lien/dashboard");
					}, 2000);
				}
			} else {
				handleClear();
				setLoading(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			setLoading(false);
			openNotification(
				"error",
				"Error",
				"Error while trying to add images signature"
			);
			console.error(err.message);
			return null;
		}
	};

	const onFinish = () => {
		if (!signatureExist) {
			if (signaturePadRef.current.isEmpty()) {
				message.error("Please provide a signature before submitting.");
				return;
			}
		}

		const values = form.getFieldsValue();
		let finalValues = {
			...values,
			deadline: dayjs(values.deadline).toDate(),
			dateDelivered: dayjs(values.dateDelivered).toDate(),
		};
		updateLien(finalValues);
	};

	const handleClear = () => {
		signaturePadRef.current.clear();
	};

	const normFile = (e) => {
		if (Array.isArray(e)) {
			return e;
		}
		return e?.fileList;
	};

	const onChangeDemandLetter = ({ file }) => {
		if (file.status === "removed") {
			setDemandLetterRemoved(true);
			setDemandLetterAdded(false);
		}
		if (!file.status) {
			setDemandLetterAdded(true);
			setDemandLetterRemoved(false);
		}
	};

	const onChangeIntentToLien = ({ file }) => {
		if (file.status === "removed") {
			setIntentToLienRemoved(true);
			setIntentToLienAdded(false);
		}
		if (!file.status) {
			setIntentToLienAdded(true);
			setIntentToLienRemoved(false);
		}
	};

	const onChangeInvoice = ({ file }) => {
		if (file.status === "removed") {
			setInvoiceRemoved(true);
			setInvoiceAdded(false);
		}
		if (!file.status) {
			setInvoiceAdded(true);
			setInvoiceRemoved(false);
		}
	};

	const onChangeLienAffidavit = ({ file }) => {
		if (file.status === "removed") {
			setLienAffidavitRemoved(true);
			setLienAffidavitAdded(false);
		}
		if (!file.status) {
			setLienAffidavitAdded(true);
			setLienAffidavitRemoved(false);
		}
	};

	const onChangeCountyReceipt = ({ file }) => {
		if (file.status === "removed") {
			setCountyReceiptRemoved(true);
			setCountyReceiptAdded(false);
		}
		if (!file.status) {
			setCountyReceiptAdded(true);
			setCountyReceiptRemoved(false);
		}
	};

	const onChangeAgreement1 = ({ file }) => {
		if (file.status === "removed") {
			setAgreement1Removed(true);
			setAgreement1Added(false);
		}
		if (!file.status) {
			setAgreement1Added(true);
			setAgreement1Removed(false);
		}
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				style={{ marginTop: "20px" }}
				initialValues={initialValues}
			>
				<Divider />
				<Row gutter={16}>
					<Col span={24}>
						<Form.Item
							label="Document No."
							name="documentNo"
							rules={[
								{
									required: true,
									message: "Document No is required",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} sm={12}>
						<Form.Item
							label="Property Owner's Name"
							name="ownerName"
							rules={[
								{
									required: true,
									message: "Property Owner's Name is required",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} sm={12}>
						<Form.Item
							label="Property Owner's Address"
							name="ownerAddress"
							rules={[
								{
									required: true,
									message: "Property Owner's Address is required",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} sm={12}>
						<Form.Item
							label="Contractor's Name"
							name="contractorName"
							rules={[
								{
									required: true,
									message: "Contractor's Name is required",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} sm={12}>
						<Form.Item
							label="Contractor's Address"
							name="contractorAddress"
							rules={[
								{
									required: true,
									message: "Contractor's Address is required",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} sm={12}>
						<Form.Item
							label="Company Name"
							name="companyName"
							rules={[
								{
									required: true,
									message: "Company Name is required",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} sm={12}>
						<Form.Item
							label="Company Address"
							name="companyAddress"
							rules={[
								{
									required: true,
									message: "Company Address is required",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} sm={12}>
						<Form.Item
							label="Property Address"
							name="propertyAddress"
							rules={[
								{
									required: true,
									message: "Property Address is required",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} sm={12}>
						<Form.Item
							label="Deadline"
							name="deadline"
							rules={[
								{
									required: true,
									message: "Deadline Address is required",
								},
							]}
						>
							<DatePicker
								size="large"
								style={{ width: "100%" }}
								format={"MM/DD/YYYY"}
								allowClear={false}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Divider />
				<Row gutter={16}>
					<Col span={24} sm={12} lg={8}>
						<Form.Item
							label="Description of Materials	"
							name="descriptionMaterials"
							rules={[
								{
									required: true,
									message: "Description of Materials is required",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} sm={12} lg={8}>
						<Form.Item
							label="Date Delivered"
							name="dateDelivered"
							rules={[
								{
									required: true,
									message: "Date Delivered is required",
								},
							]}
						>
							<DatePicker
								size="large"
								style={{ width: "100%" }}
								format={"MM/DD/YYYY"}
								allowClear={false}
							/>
						</Form.Item>
					</Col>
					<Col span={24} sm={12} lg={8}>
						<Form.Item
							label="Price of Materials"
							name="amountCharged"
							rules={[
								{
									required: true,
									message: "Price of Materials is required",
								},
							]}
						>
							<InputNumber
								size="large"
								style={{ width: "100%" }}
								min={0}
								defaultValue={0}
								step={"0.001"}
								formatter={(value) =>
									`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
								}
								parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Divider />
				<Row gutter={16}>
					<Col span={24} sm={12} lg={8}>
						<Form.Item
							label="Princial Amount Owned"
							name="principalAmountOwned"
							rules={[
								{
									required: true,
									message: "Princial Amount Owned is required",
								},
							]}
						>
							<InputNumber
								size="large"
								style={{ width: "100%" }}
								min={0}
								defaultValue={0}
								step={"0.001"}
								formatter={(value) =>
									`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
								}
								parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							/>
						</Form.Item>
					</Col>
					<Col span={24} sm={12} lg={8}>
						<Form.Item
							label="Montly Interest Amount"
							name="montlyInterestAmount"
							rules={[
								{
									required: true,
									message: "Montly Interest Amount is required",
								},
							]}
						>
							<InputNumber
								size="large"
								style={{ width: "100%" }}
								min={0}
								defaultValue={0}
								step={"0.001"}
								formatter={(value) =>
									`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
								}
								parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							/>
						</Form.Item>
					</Col>
					<Col span={24} sm={12} lg={8}>
						<Form.Item
							label="Total Amount Owned"
							name="totalAmountOwned"
							rules={[
								{
									required: true,
									message: "Total Amount Owned is required",
								},
							]}
						>
							<InputNumber
								size="large"
								style={{ width: "100%" }}
								min={0}
								defaultValue={0}
								step={"0.001"}
								formatter={(value) =>
									`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
								}
								parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}></Row>
				<Col span={24} sm={12}>
					<Form.Item
						label="Status"
						name="status"
						rules={[
							{
								required: true,
								message: "Total Amount Owned is required",
							},
						]}
					>
						<Select
							style={{ width: "100%" }}
							size="large"
							options={[
								{
									value: "In Process",
									label: "In Process",
								},
								{
									value: "Intent to Lien",
									label: "Intent to Lien",
								},
								{
									value: "Lien Affidavit",
									label: "Lien Affidavit",
								},
								{
									value: "Closed",
									label: "Closed",
								},
							]}
						/>
					</Form.Item>
				</Col>
				<Divider />
				<Row gutter={15}>
					<Col span={24} xs={8}>
						<Form.Item
							label="Demand Letter"
							name="demandLetter"
							valuePropName="fileList"
							getValueFromEvent={normFile}
						>
							<Upload
								beforeUpload={() => false}
								maxCount={1}
								multiple={false}
								accept=".pdf, .csv, .xls, .png, .jpg, .jpeg"
								defaultFileList={defaultValueDemandLetter}
								onChange={onChangeDemandLetter}
							>
								<Button icon={<UploadOutlined />} size="large">
									Upload
								</Button>
							</Upload>
						</Form.Item>
					</Col>
					<Col span={24} xs={8}>
						<Form.Item
							label="Intent To Lien"
							name="intentToLien"
							valuePropName="fileList"
							getValueFromEvent={normFile}
						>
							<Upload
								beforeUpload={() => false}
								maxCount={1}
								multiple={false}
								accept=".pdf, .csv, .xls, .png, .jpg, .jpeg"
								defaultFileList={defaultValueIntentToLien}
								onChange={onChangeIntentToLien}
							>
								<Button icon={<UploadOutlined />} size="large">
									Upload
								</Button>
							</Upload>
						</Form.Item>
					</Col>
					<Col span={24} xs={8}>
						<Form.Item
							label="Invoice"
							name="invoice"
							valuePropName="fileList"
							getValueFromEvent={normFile}
						>
							<Upload
								beforeUpload={() => false}
								maxCount={1}
								multiple={false}
								accept=".pdf, .csv, .xls, .png, .jpg, .jpeg"
								defaultFileList={defaultValueInvoice}
								onChange={onChangeInvoice}
							>
								<Button icon={<UploadOutlined />} size="large">
									Upload
								</Button>
							</Upload>
						</Form.Item>
					</Col>
					<Col span={24} xs={8}>
						<Form.Item
							label="Lien Affidavit"
							name="lienAffidavit"
							valuePropName="fileList"
							getValueFromEvent={normFile}
						>
							<Upload
								beforeUpload={() => false}
								maxCount={1}
								multiple={false}
								accept=".pdf, .csv, .xls, .png, .jpg, .jpeg"
								defaultFileList={defaultValueLienAffidavit}
								onChange={onChangeLienAffidavit}
							>
								<Button icon={<UploadOutlined />} size="large">
									Upload
								</Button>
							</Upload>
						</Form.Item>
					</Col>
					<Col span={24} xs={8}>
						<Form.Item
							label="County Receipt"
							name="countyReceipt"
							valuePropName="fileList"
							getValueFromEvent={normFile}
						>
							<Upload
								beforeUpload={() => false}
								maxCount={1}
								multiple={false}
								accept=".pdf, .csv, .xls, .png, .jpg, .jpeg"
								defaultFileList={defaultValueCountyReceipt}
								onChange={onChangeCountyReceipt}
							>
								<Button icon={<UploadOutlined />} size="large">
									Upload
								</Button>
							</Upload>
						</Form.Item>
					</Col>
					<Col span={24} xs={8}>
						<Form.Item
							label="Agreement 1"
							name="agreement1"
							valuePropName="fileList"
							getValueFromEvent={normFile}
						>
							<Upload
								beforeUpload={() => false}
								maxCount={1}
								multiple={false}
								accept=".pdf, .csv, .xls, .png, .jpg, .jpeg"
								defaultFileList={defaultValueAgreement1}
								onChange={onChangeAgreement1}
							>
								<Button icon={<UploadOutlined />} size="large">
									Upload
								</Button>
							</Upload>
						</Form.Item>
					</Col>
				</Row>
				<Divider />
				<Row gutter={16}>
					<Col span={24}>
						<Form.Item
							label="Signor's Name"
							name="signorName"
							rules={[
								{
									required: true,
									message: "Signor's Name is required",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					{!signatureExist && (
						<Col span={24}>
							<Form.Item label="Signature" required>
								<div
									style={{
										border: "1px solid #d9d9d9",
										padding: 10,
										borderRadius: 4,
									}}
								>
									<SignatureCanvas
										ref={signaturePadRef}
										penColor="black"
										backgroundColor="rgba(255,255,255,1)"
										canvasProps={{
											style: { width: "100%" },
											height: 400,
											className: "sigCanvas",
										}}
									/>
								</div>
								<Space style={{ marginTop: 10 }}>
									<Button
										type="default"
										htmlType="button"
										onClick={handleClear}
									>
										Clear Signature
									</Button>
								</Space>
							</Form.Item>
						</Col>
					)}
				</Row>
				<Divider />
				<Title level={3}>History</Title>
				<CustomTable
					loading={loading}
					columns={columns}
					data={historyLien}
					isScroll={false}
				/>

				<Row gutter={16}>
					<Col span={24} sm={12} md={4}>
						<Button
							type="primary"
							htmlType="submit"
							loading={loadingButton}
							size="large"
							style={{
								width: "100%",
							}}
						>
							Save
						</Button>
					</Col>
				</Row>
			</Form>
		);
	};

	return (
		<Layout
			title="Update Lien"
			description="Edit current lien values"
			type="medium"
		>
			{contextHolder}
			{loading ? <CustomSpinner /> : <CustomForm />}
		</Layout>
	);
};

export default Lien;
